import React, { useEffect, useState } from "react";
import { Checkbox, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, } from "@material-ui/core";
import AddEditSvEvents from "../components/AddEditSvEvents";
import { DeletePopUp, PageLoader, STableLoader, Pagination, EmptyCollection, ExportMenu, ImportMenu, FilterComponent, RevisionHistory } from "../../../shared_elements";
import { useSnackbar } from "notistack";
import { trackActivity } from "../../../../utils/mixpanel";
import { globalDeleteService, globalExportService, globalGetService, globalPostService, globalPutService } from "../../../../globalServices";
import AddIcon from '@material-ui/icons/Add';
import { checkApiStatus,checkPermission } from "../../../utils_v2";
import SvEventsList from "../components/SvEventsList";
import { withRouter } from 'react-router';
import LinkingPopup from "../../../shared_elements/LinkingPopup";
import { gaTelesisInstance, jetStreamInstance } from "../../../../shared/components";
import NoAccess from "../../aircraftModels/components/NoAccess";

const SvEventsObj = {
    name: null,
    category: null,
    sv_interval: null,
    unit_of_measure: null,
    remarks: null,
}

const SvEventsHeader = ({ handleSelectAll, isSelectAllChecked, createSortHandler, sortInfo,deleted, isSvEvents,isEngine,isApu  }) => {
    return (
        <TableHead>
            <TableRow >
                {!deleted ? <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, }} >{checkPermission('config_data', 'maintenance_program', 'D') &&<Checkbox checked={isSelectAllChecked} onChange={handleSelectAll} color="primary" size="small" />}Action(s)</TableCell> : null }
                <TableCell >
                    {!isSvEvents && !isEngine && !isApu ? <TableSortLabel
                        active={sortInfo.sort === 'name' ? true : false}
                        direction={sortInfo.sort === 'name' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('name')}
                    >
                        Name
                    </TableSortLabel> : "Name" }
                </TableCell>
                <TableCell >
                    {!isSvEvents && !isEngine && !isApu ? <TableSortLabel
                        active={sortInfo.sort === 'asset_type' ? true : false}
                        direction={sortInfo.sort === 'asset_type' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('asset_type')}
                    >
                        Asset Type
                    </TableSortLabel> : "Asset Type" }
                </TableCell>
                <TableCell >Aircraft Type</TableCell>
                {!isSvEvents&&!isApu && !isEngine?<>
                <TableCell >Engine Type</TableCell>
                <TableCell >APU Type</TableCell>
                </>:null}
                <TableCell >Is LLP Event</TableCell>
                <TableCell >
                    {!isSvEvents && !isEngine && !isApu ? <TableSortLabel
                        active={sortInfo.sort === 'ground_time' ? true : false}
                        direction={sortInfo.sort === 'ground_time' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('ground_time')}
                    >
                        Ground Time
                    </TableSortLabel> : "Hours" }
                </TableCell>
                <TableCell >
                    {!isSvEvents && !isEngine && !isApu ? <TableSortLabel
                        active={sortInfo.sort === 'hours' ? true : false}
                        direction={sortInfo.sort === 'hours' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('hours')}
                    >
                        Hours
                    </TableSortLabel> : "Hours" }
                </TableCell>
                <TableCell >
                    {!isSvEvents && !isEngine && !isApu ? <TableSortLabel
                        active={sortInfo.sort === 'cycles' ? true : false}
                        direction={sortInfo.sort === 'cycles' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('cycles')}
                    >
                        Cycles
                    </TableSortLabel> : "Cycles" }
                </TableCell>
                <TableCell >
                    {!isSvEvents && !isEngine && !isApu ? <TableSortLabel
                        active={sortInfo.sort === 'months' ? true : false}
                        direction={sortInfo.sort === 'months' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('months')}
                    >
                        Months
                    </TableSortLabel> : "Months" }
                </TableCell>
                <TableCell >
                    {!isSvEvents && !isEngine && !isApu ? <TableSortLabel
                        active={sortInfo.sort === 'days' ? true : false}
                        direction={sortInfo.sort === 'days' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('days')}
                    >
                        Days
                    </TableSortLabel> : "Days" }
                </TableCell>
                <TableCell >
                    {!isSvEvents && !isEngine && !isApu ? <TableSortLabel
                        active={sortInfo.sort === 'year' ? true : false}
                        direction={sortInfo.sort === 'year' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('year')}
                    >
                        Year
                    </TableSortLabel> : "Year" }
                </TableCell>
                <TableCell >
                    {!isSvEvents && !isEngine && !isApu ? <TableSortLabel
                        active={sortInfo.sort === 'cost' ? true : false}
                        direction={sortInfo.sort === 'cost' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('cost')}
                    >
                        Cost(USD)
                    </TableSortLabel> : "Cost(USD)" }
                </TableCell>
                <TableCell >
                    {!isSvEvents && !isEngine && !isApu ? <TableSortLabel
                        active={sortInfo.sort === 'escalation' ? true : false}
                        direction={sortInfo.sort === 'escalation' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('escalation')}
                    >
                        Escalation (%)
                    </TableSortLabel> : "Escalation (%)" }
                </TableCell>
                <TableCell >
                    {!isSvEvents && !isEngine && !isApu ? <TableSortLabel
                        active={sortInfo.sort === 'category' ? true : false}
                        direction={sortInfo.sort === 'category' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('category')}
                    >
                        Categories
                    </TableSortLabel> : "Categories" }
                </TableCell>
                <TableCell >
                    {!isSvEvents && !isEngine && !isApu ? <TableSortLabel
                        active={sortInfo.sort === 'created_by' ? true : false}
                        direction={sortInfo.sort === 'created_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('created_by')}
                    >
                        Created By
                    </TableSortLabel> : "Created By" }
                </TableCell>
                <TableCell >
                    {!isSvEvents && !isEngine && !isApu ? <TableSortLabel
                        active={sortInfo.sort === 'updated_by' ? true : false}
                        direction={sortInfo.sort === 'updated_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('updated_by')}
                    >
                        Last Updated By
                    </TableSortLabel> : "Last Updated By" }
                </TableCell>
                <TableCell >
                    {!isSvEvents && !isEngine && !isApu ? <TableSortLabel
                        active={sortInfo.sort === 'remarks' ? true : false}
                        direction={sortInfo.sort === 'remarks' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('remarks')}
                    >
                        Remarks
                    </TableSortLabel> : "Remarks" }
                </TableCell>
            </TableRow>
        </TableHead>
    )
}

const SvEvents = ({params,isSvEvents,deleted,isEngine,isApu,aircraftTypeName,linkedTypeName}) => {
    // linkage history: linked_id is the screen's record id; APU / Engine screens also send linked_key
    const linkedParams = isSvEvents ? { linked_id: params?.id } : isApu ? { linked_id: params?.id, linked_key: 'apu_type' } : isEngine ? { linked_id: params?.id, linked_key: 'engine_type' } : {};
    const linkedName = isSvEvents ? aircraftTypeName : linkedTypeName;

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState({});
    const [pageSelections, setPageSelections] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [bulkDelete, setBulkDelete] = useState({ modal: false, data: null })
    const [bulkRevert, setBulkRevert] = useState({ modal: false, data: null })
    const [bulkUnlink, setBulkUnLink] = useState({ modal: false, data: null })
    const [addEditSvEvents, setAddEditSvEvents] = useState({ modal: false, data: null });
    const [unLinkSvEvents, setUnLinkSvEvents] = useState({ modal: false, data: null });
    const [deleteSvEvents, setDeleteSvEvents] = useState({ modal: false, data: null });
    const [revertSvEvents, setRevertSvEvents] = useState({ modal: false, data: null });
    const [svEventsInfo, setSvEventsInfo] = useState({ list: [], pagination: {} });
    const [linkingSvEvents, setLinkingSvEvents] = useState({ modal: false, data: null });
    const [circularLoader, setCircularloader] = useState(false);
    const [pltConstants, setPltConstants] = useState([]);
    const [categoryInfo, SetCategoryInfo] = useState([]);

    useEffect(() => {
        getSvEvents({ per_page: 50 }, !isSvEvents && !isEngine && !isApu ? "skeletonLoader" : "pageLoader");
        trackActivity('Console Management', { page_title: isSvEvents ? 'Config Data : Aircraft Types View page' : isEngine ? 'Config Data : Engine Types View page' : isApu ? 'Config Data : Apu Types View page' : 'Config Data : Shop Visit Events' , event_type: !isSvEvents && !isEngine && !isApu ?'Page Visited' : 'Maintenance Programs Tab Clicked' })
        getPltConstants();
        getcategory();
    }, [])
 

    const getSvEvents = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)

        const url = isSvEvents?`/config-data/asset-type-sv-events/aircraft/${params?.id}/`: isEngine ? `/config-data/asset-type-sv-events/engine/${params?.id}/`: isApu ? `/config-data/asset-type-sv-events/apu/${params?.id}/` : `config-data/sv-events/`

        globalGetService(url, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setSvEventsInfo(response.data.data)
                    if(query){
                        delete query.page
                        delete query.per_page
                        delete query.sort
                        delete query.sort_by
                        setFilter(query)
                    }
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }

    const onDelete = () => {
        setLoading(true);
        const ids = !deleteSvEvents.data ? Object.values(pageSelections).flat().filter(id => {
            const item = svEventsInfo.list.find(item => item.id === id);
            return item && !item.deleted_at;
        }) : deleteSvEvents.data.id

        globalDeleteService(`config-data/sv-events/bulk-delete/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteSvEvents({ modal: false, data: null });
                    getSvEvents({ ...filter, page: svEventsInfo?.pagination?.page, per_page: svEventsInfo?.pagination?.per_page }, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false);
                    setPageSelections({});
                    setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Region',
                        event_type: `Item Deleted`,
                        event_desc: 'Region Deleted Successfully',
                        success_msg: response?.data?.message,
                        deleted_id: ids
                    });
                } else {
                    setDeleteSvEvents({ modal: false, data: null });
                    setLoading(false);
                    setPageSelections({});
                    setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Region',
                        event_type: `Item Deleted`,
                        event_desc: 'Region Deletion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const onRevert = () => {
        setLoading(true);
        const ids = !revertSvEvents.data ? Object.values(pageSelections).flat().filter(id => {
            const item = svEventsInfo.list.find(item => item.id === id);
            return item && item.deleted_at;
        }) : revertSvEvents.data;

        globalPutService(`config-data/sv-events/restore/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setRevertSvEvents({ modal: false, data: null });
                    getSvEvents({ ...filter, page: svEventsInfo?.pagination?.page, per_page: svEventsInfo?.pagination?.per_page }, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false);
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Region',
                        event_type: `Item Reverted`,
                        event_desc: 'Region Reverted Successfully',
                        success_msg: response?.data?.message,
                        reverted_id: ids
                    });
                } else {
                    setRevertSvEvents({ modal: false, data: null });
                    setLoading(false);
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Region',
                        event_type: `Item Reverted`,
                        event_desc: 'Region Reversion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const linkUnlink = (type, ids) => {
        const idss = !unLinkSvEvents.data ? Object.values(pageSelections).flat().filter(id => id) : [unLinkSvEvents?.data?.id]
        let payload;
        if (type === 'link') {
            payload = {
                sv_events: ids,
                action: 'link'
            };
        } else {
            payload = {
                sv_events: idss,
                action: 'unlink'
            };
        }

        const apiUrl = isSvEvents ? `/config-data/asset-type-sv-events/aircraft/${params?.id}/` : isEngine ? `/config-data/asset-type-sv-events/engine/${params?.id}/` : `/config-data/asset-type-sv-events/apu/${params?.id}/`;
        setCircularloader(true);
        globalPostService(apiUrl, payload)
            .then((response) => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    toggleModalFn();
                    getSvEvents();
                    setPageSelections({})
                    trackActivity('Console Management', {
                        event_desc: type === 'link'? `Shop Visit Event Linked Successfully` : 'Shop Visit Event unLinked Successfully',
                        page_title: 'Config Data : Aircraft Types View Page',
                        event_type: type === 'link' ? 'Item Linked' : 'Item UnLinked',
                        updated_id: type === 'link'? ids : idss || null,
                        success_msg: response?.data?.message,
                        data:JSON.stringify(payload)
                    })
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    getSvEvents();
                    toggleModalFn();
                    setPageSelections({})
                    trackActivity('Console Management', {
                        event_desc: type === 'link'? 'Shop Visit Event Linking Failed' : 'Shop Visit Event Unlinking Failed',
                        page_title: 'Config Data : Aircraft Types View Page',
                        event_type: type === 'link' ? 'Item Linked' : 'Item UnLinked',
                        updated_id: type === 'link'? ids : idss || null,
                        error_msg: response?.data?.message,
                        data:JSON.stringify(payload)
                    })
                }
                setCircularloader(false);
            })
    }


    const toggleBulkOps = (item, checked, currentPage) => {
        setPageSelections(prevSelections => {
            const updatedSelections = { ...prevSelections };
            if (checked) {
                updatedSelections[currentPage] = updatedSelections[currentPage] || [];
                updatedSelections[currentPage].push(item?.id);
            } else {
                updatedSelections[currentPage] = updatedSelections[currentPage]?.filter(id => id !== item?.id);
            }
            return updatedSelections;
        });
    };

    const handleSelectAll = (event, currentPage) => {
        if (event?.target.checked) {
            const allIds = svEventsInfo?.list.map(item => item.id);
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: allIds }));
        } else {
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: [] }));
        }
    };

    const getFilteredSelectionCounts = () => {
        let deleteCount = 0;
        let revertCount = 0;

        if (pageSelections[currentPage]?.length) {
            pageSelections[currentPage].forEach(id => {
                const selectedItem = svEventsInfo?.list?.find(item => item?.id === id);
                if (selectedItem) {
                    if (selectedItem?.deleted_at) {
                        revertCount++;
                    } else {
                        deleteCount++;
                    }
                }
            });
        }
        return { deleteCount, revertCount };
    };

    const { deleteCount, revertCount } = getFilteredSelectionCounts();

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getSvEvents({ ...filter, ...sortQuery, page: 1, per_page: svEventsInfo?.pagination?.per_page || 20 }, 'pageLoader');
    }

    const isSelectAllChecked = svEventsInfo?.list?.length > 0 && pageSelections[currentPage]?.length === svEventsInfo?.list?.length;

    const getConfirmColor = () => {
        if (revertSvEvents?.modal || bulkRevert?.modal) return "primary";
        if (deleteSvEvents?.modal || bulkDelete?.modal) return "secondary";
        if (unLinkSvEvents?.modal || bulkUnlink?.modal) return "secondary";
        return "";
    };

    const getConfirmText = () => {
        if (revertSvEvents?.modal || bulkRevert?.modal) return "Revert";
        if (deleteSvEvents?.modal || bulkDelete?.modal) return "DELETE";
        if (unLinkSvEvents?.modal || bulkUnlink?.modal) return "UnLink"
        return "";
    };

    const getModal = () => {
        if (revertSvEvents?.modal) return revertSvEvents.modal;
        if (deleteSvEvents?.modal) return deleteSvEvents.modal;
        if (bulkDelete?.modal) return bulkDelete.modal;
        if (bulkRevert?.modal) return bulkRevert.modal;
        if (unLinkSvEvents?.modal) return unLinkSvEvents.modal;
        if (bulkUnlink?.modal) return bulkUnlink.modal;
        return null;
    };

    const getTitle = () => {
        if (revertSvEvents?.modal) return "Revert Shop Visit Events";
        if (deleteSvEvents?.modal) return "Delete Shop Visit Events";
        if (bulkDelete?.modal) return `Delete Shop Visit Events (${deleteCount})`;
        if (bulkRevert?.modal) return `Revert Shop Visit Events (${revertCount})`;
        if (unLinkSvEvents?.modal) return "UnLink Shop Visit Events"
        if (bulkUnlink?.modal) return `Unlink Shop Visit Events (${deleteCount})`
        return "";
    };

    const getContent = () => {
        if (revertSvEvents?.modal || bulkRevert?.modal)
            return "Are you sure, you want to Revert?";
        if (deleteSvEvents?.modal || bulkDelete?.modal)
            return "Are you sure, you want to Delete?";
        if (unLinkSvEvents?.modal || bulkUnlink?.modal)
            return "Are you sure, you want to UnLink"
        return "";
    };

    const toggleModalFn = () => {
        if (revertSvEvents?.modal) {
            setRevertSvEvents({ modal: false, data: null });
        } else if (deleteSvEvents?.modal) {
            setDeleteSvEvents({ modal: false, data: null });
        } else if (bulkDelete?.modal) {
            setBulkDelete({ modal: false, data: null });
        } else if (bulkRevert?.modal) {
            setBulkRevert({ modal: false, data: null });
        } else if (bulkUnlink?.modal) {
            setBulkUnLink({ modal: false, data: null });
        } else if (unLinkSvEvents?.modal) {
            setUnLinkSvEvents({ modal: false, data: null});
        } else {
            setLinkingSvEvents({ modal: false, data: null});
        }
    };

    const getDeleteRecordFn = () => {
        if (revertSvEvents?.modal || bulkRevert?.modal) return onRevert;
        if (deleteSvEvents?.modal || bulkDelete?.modal) return onDelete;
        if (unLinkSvEvents?.modal || bulkUnlink?.modal) return  linkUnlink || null;
        return null;
    };
    const getPltConstants = () => {
        globalPostService('console/get-constants/', { constant_types: ['asset_type'] })
            .then(response => {
                if (checkApiStatus(response)) {
                    setPltConstants(response.data.data)
                }
            })
    }
    const getcategory = () => {
        globalGetService(`config-data/categories/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let categoryInfo = [];
                    const data = response?.data?.data;
                    data && data.map((item) => {
                        categoryInfo.push({ id: item?.id, name: item?.name })
                    });
                    SetCategoryInfo(categoryInfo);
                }
            })
    }

    const filterOption = (
		{
			'name': {
				'inputType': 'text',
				'title': 'Name',
			},
		    'asset_type': {
                'inputType': 'dropdown',
                'title': 'Asset Type',
                'options': pltConstants?.filter(optionItem => optionItem?.type === 'asset_type' && (jetStreamInstance || optionItem?.value !== 10)  && (!gaTelesisInstance || [1, 2, 3, 4].includes(optionItem?.value))),
                'labelKey': 'label',
                'valueKey': 'value',
            },
            'category':{
                'inputType': 'dropdown',
                'title': 'Category',
                'options': categoryInfo,
                'labelKey': 'name',
                'valueKey': 'id',
            }
        })

    return (
        <>
        {checkPermission('config_data', 'maintenance_program', 'R') ?
        <> {skeletonLoader ? <STableLoader count={6} /> :
                <div style={{ paddingTop: isSvEvents || isEngine || isApu ? '8px' : "10px" }}>
                    <Paper elevation={0} className="console-paper" style={{ padding: '4px 8px', marginBottom: "2px" }}>
                        <Grid container spacing={1} alignItems="center">
                            <Grid item md={6}>
                                    {!isSvEvents && !isEngine && !isApu ? <FilterComponent
                                        filter={filter}
                                        filterMenu={filterOption}
                                        getResponseBack={(applyFilter) => { getSvEvents({ ...applyFilter, page: 1, per_page: svEventsInfo?.pagination?.per_page || 10 }, 'pageLoader') }}
                                    /> : null }
                            </Grid>
                            <Grid item md={6}>
                                {!isSvEvents && !isEngine && !isApu ? <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                    {revertCount > 0 && (
                                        <li className='list-inline-item'>
                                            <Button onClick={() => { setBulkRevert({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Region', item_type: 'Bulk Revert', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Revert Modal from Region` }) }} color="primary" size='small' variant="outlined">
                                                Revert ({revertCount})
                                            </Button>
                                        </li>
                                    )}
                                    {deleteCount > 0 && (
                                        <li className='list-inline-item'>
                                            <Button onClick={() => { setBulkDelete({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Region', item_type: 'Bulk Delete', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Delete Modal from Region` }) }} color="secondary" size='small' variant="contained">
                                                Delete ({deleteCount})
                                            </Button>
                                        </li>
                                    )}
                                    {checkPermission('config_data', 'maintenance_program', 'C') &&  <li className='list-inline-item'>
                                        <Button onClick={() => setAddEditSvEvents({ modal: true, data: SvEventsObj, type: 'add' })} color="primary" size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />ADD</Button>
                                    </li>}
                                    <li className='list-inline-item' style={{ cursor: 'pointer' }}>
                                        <RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdsveventmaintenanceprograms/`} queryParams={{ action: '0,1,2' }} />
                                    </li>
                                </ul> : !deleted ?
                                    <ul style={{ textAlign: "right" }}>
                                            {deleteCount > 0 && checkPermission('config_data', 'maintenance_program', 'D') && (
                                                <li className='list-inline-item'>
                                                    <Button onClick={() => { setBulkUnLink({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Shop Visit Events', item_type: 'Bulk Unlink', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Unlink Shop Visit Events to Aircraft Type` }) }} color="secondary" size='small' variant="contained">
                                                        Unlink ({deleteCount})
                                                    </Button>
                                                </li>)}
                                                { checkPermission('config_data', 'maintenance_program', 'U') &&   <li className='list-inline-item'>
                                            <Button onClick={() => setLinkingSvEvents({ modal: true, data:svEventsInfo})} color="primary" size='small' variant="contained">Link Shop Visit</Button>
                                        </li>}
                                                <li className='list-inline-item' style={{ cursor: 'pointer', verticalAlign: 'middle' }}>
                                                    <RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdsveventmaintenanceprograms/`} queryParams={{ action: '0,1,2', ...linkedParams }} linkedName={linkedName} objectReprLabel={isSvEvents || isEngine || isApu} linkField={isEngine ? 'engine_type' : isApu ? 'apu_type' : 'aircraft_type'} />
                                                </li>
                                    </ul> : null}
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper square>
                        <div style={{ height: isSvEvents ? `${window.innerHeight - (svEventsInfo?.list?.length ? 535 : 480)}px` : isEngine ? `${window.innerHeight - (svEventsInfo?.list?.length ? 575 : 520)}px` : isApu ? `${window.innerHeight - (svEventsInfo?.list?.length ? 490 : 435)}px` : `${window.innerHeight - (svEventsInfo?.list?.length ? 250 : 200)}px`, overflow: 'auto' }}>
                        <Table className="mui-table-format" stickyHeader>
                            <SvEventsHeader isSelectAllChecked={isSelectAllChecked} deleted={deleted} handleSelectAll={(e) => handleSelectAll(e, currentPage)} createSortHandler={createSortHandler} sortInfo={sortInfo} isSvEvents={isSvEvents} isApu={isApu} isEngine={isEngine} />
                            <TableBody>
                                {svEventsInfo?.list?.length > 0 && svEventsInfo?.list?.map((item, index) =>
                                    <SvEventsList
                                                    linkedParams={linkedParams}
                                                    linkedName={linkedName}
                                        isSvEvents={isSvEvents}
                                        isEngine={isEngine}
                                        isApu={isApu}
                                        deleted={deleted}
                                        item={item}
                                        index={index}
                                        unLink={setUnLinkSvEvents}
                                        onDelete={setDeleteSvEvents}
                                        onRevert={setRevertSvEvents}
                                        onEditFn={() => setAddEditSvEvents({ modal: true, data: item, type: 'edit' })}
                                        onViewFn={() => setAddEditSvEvents({ modal: true, data: item, type: 'view' })}
                                        toggleBulkOps={(item, checked) => toggleBulkOps(item, checked, currentPage)}
                                        bulkIds={pageSelections[currentPage] || []}
                                    />
                                )}
                            </TableBody>
                        </Table>
                         {!svEventsInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                        </div>
                    </Paper>
                    <Paper square>
                        <Pagination
                            pagination={svEventsInfo?.pagination}
                            onChangePage={(event, newPage) => { getSvEvents({ ...filter, page: newPage + 1, per_page: svEventsInfo.pagination?.per_page, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader'); setCurrentPage(newPage + 1) }}
                            onChangeRowsPerPage={(event) => getSvEvents({ ...filter, page: 1, per_page: event.target.value, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader')}
                        />
                    </Paper>
                </div>}</> : <NoAccess />}
            {addEditSvEvents.modal ?
                <AddEditSvEvents
                    addEditSvEvents={addEditSvEvents}
                    svEventsInfo={svEventsInfo}
                    toggleModalFn={() => setAddEditSvEvents({ modal: false, svEventsData: [] })}
                    getResponseBack={() => getSvEvents({ ...filter, page: svEventsInfo?.pagination?.page, per_page: svEventsInfo?.pagination?.per_page }, 'pageLoader')}
                    modeType={addEditSvEvents?.type}
                /> : null
            }
            <DeletePopUp
                confirmColor={getConfirmColor()}
                confirmText={getConfirmText()}
                modal={getModal()}
                title={getTitle()}
                content={getContent()}
                toggleModalFn={toggleModalFn}
                deleteRecordFn={getDeleteRecordFn()}
                circularloader={circularLoader}
            />
            {isLoading ? <PageLoader /> : null}
            {linkingSvEvents.modal &&
                <LinkingPopup 
                  isSvEvents={isSvEvents}
                  isEngine={isEngine}
                  isApu={isApu}
                  title="Shop Visit"
                  circularloader={circularLoader}
                  linkUnlink = {(type,ids)=>linkUnlink(type,ids)}
                  placeholder='Search By Shop Visit Events ...'
                  description='No Shop Visit Events is available to link'
                  url={isSvEvents ? `/config-data/asset-type-sv-events/aircraft/?dropdown=true&asset_type_id=${params?.id}` : isEngine ? `/config-data/asset-type-sv-events/engine/?dropdown=true&asset_type_id=${params?.id}` : `/config-data/asset-type-sv-events/apu/?dropdown=true&asset_type_id=${params?.id}`}
                  data={svEventsInfo}
                  toggleModalFn={() => setLinkingSvEvents({modal:false, data:null})}
                />
                } 
        </>
    )

}

export default withRouter(SvEvents);